import Vue from 'vue';
import moment from 'moment';

Vue.filter('dateformat', function (value, formatting) {
    moment.locale('nl');
    return moment(value).format(formatting);
});

Vue.filter('external_link', function (value) {
    if(value.indexOf('http') !== 0) {
        value = `http://${value}`;
    }

    return value;
});